var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarningInfoCircle = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Info Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000198364 19.9985C0.000198364 8.96054 8.9602 -0.00146484 20.0002 -0.00146484C31.0602 -0.00146484 40.0002 8.96054 40.0002 19.9985C40.0002 31.0405 31.0602 39.9985 20.0002 39.9985C8.9602 39.9985 0.000198364 31.0405 0.000198364 19.9985ZM18.2402 12.4185C18.2402 11.4605 19.0402 10.6585 20.0002 10.6585C20.9602 10.6585 21.7402 11.4605 21.7402 12.4185V21.2585C21.7402 22.2205 20.9602 22.9985 20.0002 22.9985C19.0402 22.9985 18.2402 22.2205 18.2402 21.2585V12.4185ZM20.0202 29.3605C19.0402 29.3605 18.2602 28.5605 18.2602 27.6005C18.2602 26.6405 19.0402 25.8605 20.0002 25.8605C20.9802 25.8605 21.7602 26.6405 21.7602 27.6005C21.7602 28.5605 20.9802 29.3605 20.0202 29.3605Z",
    fill: "#D29822"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningInfoCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warningInfoCircle.7fefe3cb.svg";
export { ForwardRef as ReactComponent };